import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import {
  ErrorTemplate,
  ErrorTemplateActions,
  ErrorTemplateContent,
  ErrorTemplateDescription,
  ErrorTemplateLogo,
  ErrorTemplateTitle,
  ErrorTemplateUrl,
} from "@arcadeai/design-system/components/ui/templates/error-template";
import { Link, useLocation, useRouter } from "@tanstack/react-router";
import { ArrowLeft, Home } from "lucide-react";
import { useCallback, useRef } from "react";
import Logo from "@/assets/images/arcade-logo.svg";

export const NotFoundRoute = () => {
  const location = useLocation();
  const router = useRouter();
  const canGoBack = useRef(router.history.canGoBack()).current;

  const missingPath =
    typeof window === "undefined"
      ? location.pathname
      : `${window.location.pathname}${window.location.search}`;

  const handleGoBack = useCallback(() => {
    router.history.back();
  }, [router]);

  return (
    <ErrorTemplate>
      <ErrorTemplateContent>
        <ErrorTemplateLogo>
          <img
            alt="Arcade"
            className="h-7 w-auto invert dark:invert-0"
            height={28}
            src={Logo}
            width={86}
          />
        </ErrorTemplateLogo>

        <p className="select-none font-mono text-[9rem] tabular-nums leading-none tracking-tighter sm:text-[11rem]">
          404
        </p>

        <ErrorTemplateTitle className="mt-6">Page not found</ErrorTemplateTitle>
        <ErrorTemplateDescription>
          The page may have moved or the link may be incorrect.
        </ErrorTemplateDescription>
        <ErrorTemplateUrl url={missingPath} />

        <ErrorTemplateActions>
          <Button
            className="h-12 min-w-[160px] px-10 font-semibold text-base shadow-lg transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl"
            render={<Link to="/" />}
            size="lg"
          >
            <Home className="mr-2 h-4 w-4" />
            Go Home
          </Button>
          {canGoBack && (
            <Button
              className="h-11 min-w-[140px] px-8 text-base transition-transform hover:-translate-y-0.5"
              onClick={handleGoBack}
              size="lg"
              variant="outline"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Go Back
            </Button>
          )}
        </ErrorTemplateActions>
      </ErrorTemplateContent>
    </ErrorTemplate>
  );
};
